import { createInjectableHook } from '../createInjectableHook'

export const [useIsNuxtReady, provideUseIsNuxtReady] = createInjectableHook(
  () => {
    const isNuxtReady = ref(false)
    onNuxtReady(() => {
      isNuxtReady.value = true
    })
    return {
      isNuxtReady,
    }
  },
)
